<template>
  <loader :is-loading="loading" color="primary"></loader>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  async beforeCreate() {
    const { fleetId } = this.$route.query;
    await this.$store.dispatch('paymentOnboarding/validate', fleetId);
    this.loading = false;
    this.$router.push('/captures');
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>
